module.exports = __webpack_public_path__ + "img/process.bc4d3b1f.png";